import { render, staticRenderFns } from "./recently_lou_plus.vue?vue&type=template&id=ac52ccc0&scoped=true&"
import script from "./recently_lou_plus.vue?vue&type=script&lang=js&"
export * from "./recently_lou_plus.vue?vue&type=script&lang=js&"
import style0 from "./recently_lou_plus.vue?vue&type=style&index=0&id=ac52ccc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac52ccc0",
  null
  
)

export default component.exports